<div class="renewal-opt-out-label"
     *ngIf="((productTypeCode === ProductTypeCode.sda ||
        productTypeCode === ProductTypeCode.umbrellaSda) &&
        isRenewalOptIn === false)">
  <span title="Resident actively opted out from Qira alternative program">Renewal Disabled</span>
</div>
